import { useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { VersandmitteilungDialog } from "@/components/VersandmitteilungDialog";

const booked = (s) => s.status !== "fehler" && (s.gebucht || s.label_url);

// Aktion im Auftragskopf: neueste gebuchte Sendung, bei mehreren Auswahl
export const VersandmitteilungHeaderButton = ({ order, onSent }) => {
  const [list, setList] = useState(null);
  const [chosen, setChosen] = useState(null);
  const [loading, setLoading] = useState(false);

  const start = async () => {
    setLoading(true);
    try {
      const r = await api.get("/versand", { params: { order_id: order.id } });
      const items = r.data.filter(booked).sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
      if (!items.length) toast.error("Noch keine gebuchte Sendung – bitte zuerst im Abschnitt Versand ein Paket buchen.");
      else if (items.length === 1) setChosen(items[0]);
      else setList(items);
    } catch { toast.error("Sendungen konnten nicht geladen werden."); }
    finally { setLoading(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={start} disabled={loading} data-testid="auftrag-versandmitteilung-button">
        {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />} Versandmitteilung senden
      </Button>
      <Dialog open={!!list} onOpenChange={(o) => !o && setList(null)}>
        <DialogContent className="max-w-md" data-testid="versandmitteilung-picker">
          <DialogHeader><DialogTitle>Sendung wählen</DialogTitle></DialogHeader>
          <ul className="space-y-2">
            {(list || []).map((s, i) => (
              <li key={s.id}>
                <button type="button" onClick={() => { setList(null); setChosen(s); }} data-testid={`versandmitteilung-pick-${s.id}`}
                  className="w-full text-left p-3 rounded-md border border-slate-200 hover:border-blue-400 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-colors">
                  <div className="text-sm font-medium">{i === 0 ? "Neueste: " : ""}{s.tracking_number || s.versanddienst || s.versandart} · {fmtDateTime(s.created_at)}</div>
                  <div className="text-xs text-slate-500">{s.zusatzpaket ? "Zusätzliches Paket" : s.letztes_paket ? "Letztes Paket" : "Teillieferung"}{s.versandmitteilung_gesendet_am ? ` · gesendet ${fmtDateTime(s.versandmitteilung_gesendet_am)}` : ""}</div>
                </button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
      {chosen && <VersandmitteilungDialog shipment={chosen} open={!!chosen} onOpenChange={(o) => !o && setChosen(null)} onSent={onSent} />}
    </>
  );
};
